module.exports = __webpack_public_path__ + "img/6.dc68ae85.png";